import HubSpotAppDrawer from './HubSpotAppDrawer';

const drawers = [HubSpotAppDrawer];

export default drawers;
